<template>
  <div
    class="breadcrumbs hidden-print">
    <template
      v-for="(item, itemIndex) in breadcrumbs">
      <div
        v-if="item.loading"
        :key="`${itemIndex}-skeleton`"
        class="breadcrumb__skeleton"/>
      <component
        v-else-if="item[item_text] || item.text"
        :is="item.to ? 'router-link' : 'div'"
        :key="`${itemIndex}-component`"
        :class="className(item)"
        :to="item.to"
        @click="onItemClick(item, $event)"
        @click.native="onItemClick(item, $event)">
        <span
          v-if="item.index === 0"
          class="flex mr-2"
          style="position: relative; height: 24px;">
          <img
            :src="`${siteHref}/img/icons/small-logo.svg`">
          <img
            v-if="ny"
            :src="`${siteHref}/img/cap-ny.svg`"
            style="position: absolute; left: 15px; top: -9px; width: 20px; transform: rotateZ(28deg);">
        </span>
        <TooltipedText
          :max-length="item.maxLength || 10"
          style="line-height: 1;"
          :value="item[item_text] || item.text"/>
      </component>

      <sIcon
        v-if="itemIndex !== breadcrumbs.length-1"
        :key="`${itemIndex}-Icon`"
        class="mx-2"
        line-height="24px"
        rotate="-90"
        size="9"
        type="arrow"/>
    </template>
  </div>
</template>

<script>
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'

export default {
  name: 'breadcrumbs',
  data() {
    return {
      ny: false,
      siteHref: window.config?.BaseUrl,
    }
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    item_text: String,
    item_action: String,
    disabled: Boolean
  },
  computed: {
    breadcrumbs() {
      return (this.items || []).map((elem, index) => {
        const action = elem?.[this.item_action] || elem?.action || (() => { this.$log && this.$log('breadcrumbs') })
        return {
          ...elem,
          index,
          action
        }
      })
    }
  },
  methods: {
    className(item) {
      const isCurrent = item.index === this.items.length - 1 || item.current
      const base = 'flex py-1'
      const state = isCurrent ? ' current' : ' parent'
      const extra = item.class ? ` ${item.class}` : ''
      const disabled = this.disabled ? ' disabled' : ''
      return `${base}${state}${extra}${disabled}`
    },
    onItemClick(item, e) {
      if (this.disabled) {
        if (e && typeof e.preventDefault === 'function') {
          e.preventDefault()
        }
        return
      }
      if (typeof item.action === 'function') {
        const res = item.action(e)
        if (res === false && e && typeof e.preventDefault === 'function') {
          e.preventDefault()
        }
      }
    }
  },
  mounted() {
    const date = new Date()
    this.ny = (date.getMonth() === 11 && date.getDate() >= 15) || (date.getMonth() === 0 && date.getDate() <= 15)
  },
  components: {
    TooltipedText
  }
}
</script>

<style scoped lang="scss">
.breadcrumbs {
  margin: 0;
  flex: 0 1 auto;
  align-items: center;
  list-style-type: none;
  display: flex;
  padding: 0;
}
.breadcrumb__skeleton {
  background: rgba(var(--black-color-rgba), 0.12);
  height: 12px;
  overflow: hidden;
  width: 100px;
  margin-left: 4px;
  display: flex;
  border-radius: 4px;
  position: relative;
  cursor: progress;
  &::after {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0));
    animation: loading 1.5s infinite;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
    z-index: 1;
  }
}
</style>
